export default __webpack_public_path__ + "a6bfcd0.png";